import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import {AuthHttp} from 'angular2-jwt';
import { Observable }     from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {tokenNotExpired} from 'angular2-jwt';

import {AppSettings} from '../app-settings';

import 'rxjs/add/operator/catch';
import 'rxjs/observable/throw';

@Injectable()
export class UserService {

  public token: string;

  headers = new Headers({'Accept': 'application/json'});
  options = new RequestOptions({headers: this.headers});

  constructor(private http: Http, private authHttp: AuthHttp) {
   var currentUser = JSON.parse(localStorage.getItem('currentUser'));
   this.token = currentUser && currentUser.token;
  }

  getData(url: string): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT + url, this.options).map(response => response.json())
  }

  registerSupplier(params): Observable<any> {
   return this.http.post(AppSettings.API_STARTPOINT+"/public/api/v1/supplier/register", params, this.options).map(response => response.json());
  }

  registerSupplierMail(params): Observable<any> {
   return this.http.post(AppSettings.API_STARTPOINT+"/public/api/v1/supplier/register-mail", params, this.options).map(response => response.json());
  }

  changeSupplierActivity(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/supplier/change-activity", params, this.options).map(response => response.json());
  }

  changeSupplierActivityMail(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/supplier/change-activity-mail", params, this.options).map(response => response.json());
  }

  changeSupplierFeature(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/supplier/change-feature", params, this.options).map(response => response.json());
  }

  changeSupplierFeatureMail(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/supplier/change-feature-mail", params, this.options).map(response => response.json());
  }

  changeDistributorActivity(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/distributor/change-activity", params, this.options).map(response => response.json());
  }

  changeDistributorActivityMail(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/distributor/change-activity-mail", params, this.options).map(response => response.json());
  }

  changeGuestActivity(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/guest/change-activity", params, this.options).map(response => response.json());
  }

  changeGuestActivityMail(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/guest/change-activity-mail", params, this.options).map(response => response.json());
  }

  changeDistributorFeature(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/distributor/change-feature", params, this.options).map(response => response.json());
  }

  changeGuestFeature(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/guest/change-feature", params, this.options).map(response => response.json());
  }

  registerDistributor(params): Observable<any> {
   return this.http.post(AppSettings.API_STARTPOINT+"/public/api/v1/distributor/register", params, this.options).map(response => response.json());
  }
  
  registerDistributorMail(params): Observable<any> {
   return this.http.post(AppSettings.API_STARTPOINT+"/public/api/v1/distributor/register-mail", params, this.options).map(response => response.json());
  }

  registerGuest(params): Observable<any> {
   return this.http.post(AppSettings.API_STARTPOINT+"/public/api/v1/guest/register", params, this.options).map(response => response.json());
  }
  
  registerGuestMail(params): Observable<any> {
   return this.http.post(AppSettings.API_STARTPOINT+"/public/api/v1/guest/register-mail", params, this.options).map(response => response.json());
  }

  registerTrip(params): Observable<any> {
   return this.http.post(AppSettings.API_STARTPOINT+"/public/api/v1/trip/register", params, this.options).map(response => response.json());
  }
 
  registerTripMail(params): Observable<any> {
   return this.http.post(AppSettings.API_STARTPOINT+"/public/api/v1/trip/register-mail", params, this.options).map(response => response.json());
  }
  
  supplierProfile(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/supplier/profile", params, this.options).map(response => response.json());
  }

  supplierList(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/supplier/list", params, this.options).map(response => response.json());
  }

  supplierCompanyList(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/supplier/company-list", params, this.options).map(response => response.json());
  }

  distributorProfile(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/distributor/profile", params, this.options).map(response => response.json());
  }

  distributorList(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/distributor/list", params, this.options).map(response => response.json());
  }

  distributorCompanyList(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/distributor/company-list", params, this.options).map(response => response.json());
  }

  guestProfile(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/guest/profile", params, this.options).map(response => response.json());
  }

  getInfoAttendee(params): Observable<any>{
      if(params.type=='Supplier')
          return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/supplier/get-info-attendee', params, this.options).map(this.extractData).catch(this.handleError);
      else if(params.type=='Distributor')
          return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/distributor/get-info-attendee', params, this.options).map(this.extractData).catch(this.handleError);
      else
          return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/guest/get-info-attendee', params, this.options).map(this.extractData).catch(this.handleError);
  }

  addAttendee(params): Observable<any>{
   if(params.users.eventUser.type=='Supplier')
   return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/supplier/add-attendee', params, this.options).map(this.extractData).catch(this.handleError);
   else if(params.users.eventUser.type=='Distributor')
   return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/distributor/add-attendee', params, this.options).map(this.extractData).catch(this.handleError);
   else
   return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/guest/add-attendee', params, this.options).map(this.extractData).catch(this.handleError);
  }

  saveBalance(params): Observable<any>{
        if(params.type=='Supplier'){
            return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/supplier/save-balance', params, this.options)
                .map(this.extractData)
                .catch(this.handleError);
        }else if(params.type=='Distributor'){
            return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/distributor/save-balance', params, this.options)
                .map(this.extractData)
                .catch(this.handleError);
        }else{
            return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/guest/save-balance', params, this.options)
                .map(this.extractData)
                .catch(this.handleError);
        }
  }

  getAttendeeInfo(params): Observable<any>{
      if(params.type=='Supplier'){
          return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/supplier/get-attendee-info', params, this.options)
              .map(this.extractData)
              .catch(this.handleError);
      }else if(params.type=='Distributor'){
          return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/distributor/get-attendee-info', params, this.options)
              .map(this.extractData)
              .catch(this.handleError);
      }else {
          return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/guest/get-attendee-info', params, this.options)
              .map(this.extractData)
              .catch(this.handleError);
      }
  }

  checkEmail(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/supplier/check-email', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
  }

  editSupplierAttendee(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/supplier/save-attendee', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
  }

  editDistributorAttendee(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/distributor/save-attendee', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
  }

  editGuestAttendee(params): Observable<any>{
        return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/guest/save-attendee', params, this.options)
            .map(this.extractData)
            .catch(this.handleError);
  }

  saveTravelInfo(params): Observable<any>{
        if(params.type=='Supplier'){
            return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/supplier/save-travel-info', params, this.options)
                .map(this.extractData)
                .catch(this.handleError);
        }else if(params.type=='Distributor'){
            return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/distributor/save-travel-info', params, this.options)
                .map(this.extractData)
                .catch(this.handleError);
        }else{
            return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/guest/save-travel-info', params, this.options)
                .map(this.extractData)
                .catch(this.handleError);
        }
  }

  private extractData(res: Response) {
        let body = res.json();
        return body || [];
  }

  private handleError(error: Response | any) {
        return Observable.throw(<any>error);
  }

  changePassword(params): Observable<any> {
     return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/change-password", params, this.options).map(response => response.json());
  }

  transMail(params): Observable<any> {
     return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/user/trans-mail", params, this.options).map(response => response.json());
  }

  forgotPassword(params): Observable<any> {
   return this.http.post(AppSettings.API_STARTPOINT+"/public/api/v1/user/forgot-password", params, this.options).map(response => response.json());
  }

  supplierRotationCompanyList(params): Observable<any>{
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/supplier/trans-mail", params, this.options).map(response => response.json());
  }

  dealFormReceived(params): Observable<any>{
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/user/deal-form-received", params, this.options).map(response => response.json());
  }

  hotelRoomBooked(params): Observable<any>{
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/user/hotel-room-booked", params, this.options).map(response => response.json());
  }

  find(params): Observable<any>{
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/user/find", params, this.options).map(response => response.json());
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/common/user.service.ts